import { Divider, Drawer, Image } from "antd";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import acaciaLogo from "../../Assets/Images/Acacia-Logo.png";
import menuIcon from "../../Assets/Icons/mobile-menu.svg";
import { CloseOutlined } from "@ant-design/icons";
import { mobileNavMenuItems } from "../../Utils/staticData";
import Logo from "../Logo";
import MobileNavMenuItem from "./MobileNavMenuItem";

const poweredByAcaciaSpanStyle = {
  fontSize: "10px",
  color: "#5d5bf6",
  fontFamily: "Lexend",
  lineHeight: 1.2,
};

const poweredByFirsthandSpanStyle = {
  fontSize: "11px",
  color: "#5d5bf6",
  fontFamily: "Lexend",
};

const MobileBar = () => {
  const { pathname } = useLocation();
  const isAcacia = pathname === "/acacia";
  const [isOpenDrawer, setDrawer] = useState(false);
  const openDrawer = () => setDrawer(true);
  const closeDrawer = () => setDrawer(false);

  const poweredByLine = isAcacia ? (
    <span style={poweredByAcaciaSpanStyle}>
      Powered By <Image src={acaciaLogo} width="60px" preview={false} /> Recruits
    </span>
  ) : (
    <span style={poweredByFirsthandSpanStyle}>
      Powered By Firsthand Partners
    </span>
  );

  return (
    <div className="nav-container-mobile is-sticky">
      <div className="logo_wrapper">
        <Logo />
        <div className="powered-by-line">{poweredByLine}</div>
      </div>
      <Image src={menuIcon} width="18px" preview={false} onClick={openDrawer} />
      <Drawer
        placement="top"
        closable={false}
        onClose={closeDrawer}
        open={isOpenDrawer}
        height="auto"
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <div className="nav-container-mobile">
          <div className="logo_wrapper">
            <Logo />
            <div className="powered-by-line">{poweredByLine}</div>
          </div>
          <CloseOutlined style={{ fontSize: "24px" }} onClick={closeDrawer} />
        </div>
        <Divider />
        {mobileNavMenuItems.map(({ label, link }, index) => (
          <MobileNavMenuItem
            key={link}
            label={label}
            link={link}
            index={index}
            closeDrawer={closeDrawer}
            last={mobileNavMenuItems.length - 1}
          />
        ))}
      </Drawer>
    </div>
  );
};

export default MobileBar;
